import styled from "styled-components";

export const RefFAQContainer = styled.div`
    border: 1px solid ${({ theme }) => theme.v3.colors.grey88};
    border-radius: 18px;
    position: relative;
    cursor: pointer;

    &:hover {
        box-shadow: 0px 4px 8px rgba(27, 34, 50, 0.1);
    }
`;

export const RefFAQContainerHeader = styled.div`
    padding: 24px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const RefFAQContainerContent = styled.div<{ $noCursor: boolean }>`
    padding: 0 32px;
    overflow: hidden;
    height: 0;
    transition: height .3s ease;
    cursor: ${({ $noCursor }) => !$noCursor ? "pointer" : "initial"};
`;